import { Link, usePhoneCampaign } from '@hc-frontend/core-ui';

export interface UnstyledCTAPhoneLinkProps {
  cta: string;
}

/**
 * Renders a clickable phone link with custom CTA text
 */
export default function UnstyledCTAPhoneLink(props: UnstyledCTAPhoneLinkProps) {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <Link
        className="[all:inherit] cursor-pointer"
        id={phoneCampaign.href}
        href={phoneCampaign.href}
      >
        {props.cta}
      </Link>
    );
  }
}
